import { Link } from 'react-router-dom';

/**
 * 首页（原型无此页，按「玄墨鎏金」设计语言直接开发）：
 * 英雄区（鎏金标题 + 双入口）+ 三特性卡（占卜 / 取数 / 社区）。
 */
export function DashboardPage() {
  return (
    <section>
      {/* 英雄区 */}
      <div className="flex flex-col items-center py-14 text-center">
        <span className="chip">
          <i className="fa-solid fa-wand-sparkles text-gold-500" /> 六神煞 · 掌中诀
        </span>
        <h1 className="font-zh mt-4 text-4xl font-bold leading-tight">
          <span className="gold-text">起一卦</span>
          <span className="text-t1">，问前路</span>
        </h1>
        <p className="mt-3 max-w-xl text-[13px] leading-relaxed text-t2">
          大安起月，月上起日，日上起时，时上落宫。
          <br />
          日历取数与随机笔画取数两种方式，一针落宫，卦象立现。
        </p>
        <div className="mt-7 flex w-full max-w-xs flex-col gap-3 sm:max-w-none sm:flex-row sm:justify-center">
          <Link to="/divination" className="gold-btn gold-btn-inline no-underline">
            <i className="fa-solid fa-wand-magic-sparkles" /> 现在占卜
          </Link>
          <Link to="/board" className="ghost-btn ghost-btn-inline no-underline">
            <i className="fa-solid fa-comments" /> 去留言板
          </Link>
        </div>
      </div>

      {/* 三特性卡 */}
      <div className="grid gap-4 md:grid-cols-3">
        <FeatureCard
          icon="fa-solid fa-hand-sparkles"
          title="掌中诀推演"
          desc="六宫轮盘金针旋转落宫，三步推演过程完整可视化，卦辞详解随卦呈现。"
        />
        <FeatureCard
          icon="fa-solid fa-shoe-prints"
          title="双模式取数"
          desc="日历取数以农历为凭；随机取数凭第一印象输入 1~10 字，以笔画起卦。"
        />
        <FeatureCard
          icon="fa-solid fa-comments"
          title="轻量社区"
          desc="占卜心得发帖分享，Markdown 编辑与灵验标记，楼中楼交流理性讨论。"
        />
      </div>

      {/* 页脚提示 */}
      <p className="mt-10 text-center text-[11px] text-t3">占卜结果仅供娱乐参考 · 理性看待 · 善念常存</p>
    </section>
  );
}

/** 特性卡 */
function FeatureCard(props: { icon: string; title: string; desc: string }) {
  return (
    <div className="ink-card p-6">
      <div className="flex items-center gap-3">
        <span className="grid h-10 w-10 place-items-center rounded-xl border border-line bg-fill text-[16px] text-gold-500">
          <i className={props.icon} />
        </span>
        <h3 className="font-zh text-[15px] font-bold text-t1">{props.title}</h3>
      </div>
      <p className="mt-3 text-[13px] leading-relaxed text-t2">{props.desc}</p>
    </div>
  );
}
